import { Subject } from 'rxjs';
import { Chart } from 'chart.js';
import { ChartModel } from '../../models/azure-dashboard-view.model';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ReportingService } from '../../services/reporting.service';
import { FileService } from '../../services/file.service';
import { NgProgress } from 'ngx-progressbar';
import { CurrentUsageTenantSummaryModel, TenantUsageSummary } from '../../models/azure-dashboard-view.model';
import { Sort } from '@angular/material/sort';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../services';
import { Perpetual } from '../../models/perpetual.model';
import { TablefilterMultiplePipe } from '../../shared/pipes/tablefilter-multiple.pipe';
import { NgProgressService } from '../../services/ngProgress.service';
import { takeUntil } from 'rxjs/operators';



declare var $: any;

@Component({
  selector: 'app-esd-report',
  templateUrl: './esd-report.component.html',
  styleUrls: ['./esd-report.component.css']
})
export class EsdReportComponent implements OnInit, OnDestroy {

  title = 'ESD Report';

  reportType = '';
  fromDate: NgbDate;
  toDate: NgbDate;
  strDateFrom = '';
  strDateTo = '';

  subTitle = '';
  searchField = '';
  loadingFinished = false;
  loadContent = false;
  //export excel
  url: string;
  perpetualList : Array<Perpetual>;
  sortedData : Array<Perpetual>;
  filterResultArr: any;
   //ngUnsubscribe
   ngUnsubscribe: Subject<void> = new Subject<void>();
   narrowMode = false;
  selectedType: string;
  hasEmptyFilterResult: boolean = false;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private calendar: NgbCalendar,
    private reportingService: ReportingService,
    private commonService: CommonService,
    private fileService: FileService,
    public ngProgress: NgProgressService
  ) { }

  navigateTo(url: string) {
    this.router.navigate([url]);
  }
  
  sortData(sort: Sort) {
    let data = this.perpetualList.slice();

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'out_eu_name': return compare(a.out_eu_name.toLowerCase(), b.out_eu_name.toLowerCase(), isAsc);
        case 'out_cust_reference': return compare(a.out_cust_reference.toLowerCase(), b.out_cust_reference.toLowerCase(), isAsc);
        case 'out_order_date': return compare(a.out_order_date.toLowerCase(), b.out_order_date.toLowerCase(), isAsc);
        case 'out_order_no': return compare(a.out_order_no.toLowerCase(), b.out_order_no.toLowerCase(), isAsc);
        default: return 0;
      }
    });
  }

  ngOnInit() {
    //let startDate = new Date();
    //let endDate = new Date();
    //startDate.setDate(startDate.getDate() - 14);
    //this.fromDate = new NgbDate(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());  
    //this.toDate = new NgbDate(endDate.getFullYear(), endDate.getMonth() + 1, endDate.getDate());
    //this.selectedType = "CURRENT USAGE";
    this.narrowMode = false;
    this.fromDate = this.calendar.getNext(this.calendar.getToday(), 'd', -14);
    this.toDate = this.calendar.getToday();
    this.filterReports();
    this.loadingFinished = false;
    //this.loadContent = false;
  }
  
  convertDateFormat(): void {
    this.strDateFrom = this.fromDate.day + '/' + this.fromDate.month + '/' + this.fromDate.year;
    this.strDateTo = this.toDate.day + '/' + this.toDate.month + '/' + this.toDate.year;
  }

  validateDayRanges(btnName: string):boolean {
    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
    const utcFrom = Date.UTC(this.fromDate.year, this.fromDate.month, this.fromDate.day);
    const utcTo = Date.UTC(this.toDate.year, this.toDate.month, this.toDate.day);

    const days = Math.floor((utcTo - utcFrom) / _MS_PER_DAY);

    if (days > 100) {
      $('#' + btnName).showValidator('Report date range can be maximum of 100 days', 'error', 'right');
      return false;
    } else if (days < 1) {
      $('#' + btnName).showValidator('Invalid date range selected', 'error', 'right');
      return false;
    }
    return true;
  }

  filterReports():void {
    this.convertDateFormat();
    const isValid = this.validateDayRanges('btnFilter');
    if(!isValid) return;
    this.ngProgress.start();
    this.reportingService.getEsdReport(this.strDateFrom, this.strDateTo).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((result: any) => {
      if(result && result.output){
        this.perpetualList = result.output;
        if(this.perpetualList.length > 0){
          this.sortedData = this.perpetualList;
          this.loadingFinished = true;
        }
      }
      this.ngProgress.done();
    },
    (error: any) => {
      console.info(error),
      this.ngProgress.done();
    });
  }

  downloadReports():void {
    const isValid = this.validateDayRanges('btnDownload');
    if(!isValid) return;
    this.ngProgress.start();
    //$('#btnDownload').showValidator('Usage report will be downloaded shortly', 'success');
    this.commonService.implementToast('ESD report will be downloaded shortly', 'Info');
    this.exportEsdReport();
  }

  exportEsdReport():void {
    this.ngProgress.start();
    //convert dates before calling service methods
    this.convertDateFormat();

    this.reportingService.exportEsdReport(this.strDateFrom, this.strDateTo).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((data: any) => {
        const fileName = `ESD-${this.strDateFrom}-${this.strDateTo}.xlsx`;
        this.fileService.saveAsExcelFile(data, fileName);
        this.ngProgress.done();
        this.commonService.implementToast('ESD report downloaded successfully', 'Success');
    },
    (error: any) => {
      console.info(error);
      this.ngProgress.done();
    });
  }
 
  onActivate(componentReference) {
    componentReference.parentNarrowMode.subscribe((data) => {
       // Will receive the data from child here 
       if(data != null){
           setTimeout(() => {
            this.narrowMode = data;
           }, 100)                
       }
    })
 }

 isActive(orderNo: string, orderSuffix: string): boolean {
  return this.router.url.includes(orderNo + '/' + orderSuffix);
}

onChange() {
  this.filterResultArr = new TablefilterMultiplePipe().transform(this.sortedData, ['out_eu_name', 'out_cust_reference', 'out_order_date', 'out_order_no'], this.searchField);
  if (this.filterResultArr.length === 0 && this.searchField !=='') {
    this.hasEmptyFilterResult = true;

  } else {
    this.hasEmptyFilterResult = false;
  }
}

filterReset() {
  this.searchField = "";
  this.hasEmptyFilterResult = false;
  this.sortedData = this.perpetualList;
}

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }
  
  close() {
   // $('.page-contents').animate({ scrollLeft: -$('#levelOne').width() }, 400);
    this.router.navigateByUrl('/reporting');
  }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
